import * as React from 'react';
import {observer} from 'mobx-react';
import bind from 'bind-decorator';
import {IWidgetComponentProps} from '@mintdata-wsp/wsp/ui/views/visualDesigner/flow/panels/properties/widgets/FlowPropertiesWidgets';
import {Toggler, TogglerPosition} from '@mintdata/mint-kit/impl/properties/components/toggler/Toggler';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';

@observer
export class JavascriptWidget extends React.Component<IWidgetComponentProps, any>
{
    @bind
    private _onClick()
    {
        const {prop, block, onChange} = this.props;
        const controller = controllers.ui.flowDataPanels;

        controller.activateCodeEditorFor(block, prop, onChange);
    }

    render()
    {
        return (
            <div>
                <Toggler
                    tooltip={'Edit'}
                    position={TogglerPosition.Single}
                    isDisabled={false}
                    isPressed={false}
                    isBlock={true}
                    onClick={this._onClick}
                    text={'Edit'}
                />
            </div>
        );
    }
}
